import { Dropdown, type DropdownOption } from '@/components/ui'

interface Params {
  label: string
  values?: string[]
  onChange: (values?: string[]) => void
  options: { label: string; value: string }[]
  placeholder?: string
}

export const CustomMultiSelect: React.FC<Params> = ({ values, onChange, label, options, placeholder }) => {
  return (
    <div>
      <label>{label}</label>
      <Dropdown
        options={options}
        handleMultiSelectItem={(opt: DropdownOption[]) => {
          const selectedValues = opt.filter((option) => option.value !== '').map((option) => option.value)
          const newValues = selectedValues.length > 0 ? selectedValues : undefined
          onChange(newValues)
        }}
        isMultiSelect
        selectedItem={values ? options.filter((o) => values.includes(o.value)) : []}
        placeholder={placeholder}
      />
    </div>
  )
}
